import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { NotificationType } from "@virtualprogaming/js-public-sdk";

import {
  NotificationSettingsChoices,
  NotificationsSettings,
} from "~/ui/context";

export const getNotificationIcon = (
  notificationType: NotificationType
): [IconPrefix, IconName] => {
  switch (notificationType) {
    case NotificationType.Announcement:
      return ["fas", "megaphone"];
    case NotificationType.MessageReceived:
      return ["fab", "rocketchat"];
    case NotificationType.LikedPost:
      return ["far", "thumbs-up"];
    case NotificationType.UserFollow:
      return ["far", "user-plus"];
    case NotificationType.PostReply:
      return ["far", "comment"];
    case NotificationType.PostTag:
      return ["far", "user-tag"];
    default:
      return ["fas", "megaphone"];
  }
};

export const shouldNotShowLikeNotification = (
  notificationsSettings: NotificationsSettings,
  type: NotificationType
): boolean =>
  type === NotificationType.LikedPost &&
  !notificationsSettings[NotificationSettingsChoices.Likes];

export const shouldNotShowCommentNotification = (
  notificationsSettings: NotificationsSettings,
  type: NotificationType
): boolean =>
  type === NotificationType.PostReply &&
  !notificationsSettings[NotificationSettingsChoices.Comments];

export const shouldShowAllNotifications = (
  notificationsSettings: NotificationsSettings
): boolean => notificationsSettings[NotificationSettingsChoices.All];

export const shouldNotShowFollowNotification = (
  notificationsSettings: NotificationsSettings,
  type: NotificationType
): boolean =>
  type === NotificationType.UserFollow &&
  !notificationsSettings[NotificationSettingsChoices.Follow];

export const shouldNotShowChatNotification = (
  notificationsSettings: NotificationsSettings,
  type: NotificationType
): boolean =>
  type === NotificationType.MessageReceived &&
  !notificationsSettings[NotificationSettingsChoices.Chat];

export const parseNotificationType = (
  typeString: string
): NotificationType | undefined =>
  Object.values(NotificationType).find((type) => type === typeString) as
    | NotificationType
    | undefined;
